<template>
  <CardPrimary :style="getCardStyle">
    <div :style="containerStyle">
      <div v-if="header.length > 0"
           :style="headerContainerStyle">
        <HeaderMediumPrimary textAlign="center"
                             :truncate="!disableTruncateHeader">
          {{ header }}
        </HeaderMediumPrimary>
        <div v-if="subHeader.length > 0"
             :style="subHeaderContainerStyle">
          {{ subHeader }}
        </div>
      </div>
      <div :style="innerContainerStyle">
        <slot name="content" />
      </div>
      <ButtonPrimary v-if="buttonLabel.length > 0 && onClick"
                     :style="buttonStyle"
                     @click="onClick">
        {{ buttonLabel }}
      </ButtonPrimary>
    </div>
  </CardPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/button/button-primary'
  import CardPrimary from '@modules/card/card-primary'
  import HeaderMediumPrimary from '@modules/text/header-medium-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ItemCardPrimary',
    components: {
      ButtonPrimary,
      CardPrimary,
      HeaderMediumPrimary,
    },
    props: {
      backgroundColor: { type: [Object, String], required: false, default: null },
      buttonLabel: { type: String, required: false, default: '' },
      buttonMinWidth: { type: String, required: false, default: '62px' },
      disableTruncateHeader: { type: Boolean, required: false, default: false },
      header: { type: String, required: false, default: '' },
      onClick: { type: Function, required: false, default: () => null },
      subHeader: { type: String, required: false, default: '' },
    },
    data: function () {
      return {
        buttonStyle: {
          minWidth: this.buttonMinWidth,
        },
        containerStyle: {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'space-between',
        },
        headerContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          height: '36px',
          justifyContent: 'space-between',
          width: 'calc(100%)',
        },
        innerContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '24px',
          justifyContent: 'center',
          margin: '0 20px',
          width: '100%',
        },
        subHeaderContainerStyle: {
          fontSize: FontStyle.size.sm,
          fontWeight: FontStyle.weight.md,
          overflow: 'hidden',
          textAlign: 'center',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: '100%',
        },
      };
    },
    created: function () {
      this.subHeaderContainerStyle = {
        ...this.subHeaderContainerStyle,
        color: this.color.dark2(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      getCardStyle: function () {
        return {
          backgroundColor: this.backgroundColor ? this.backgroundColor : this.color.light1(),
          flex: 1,
          height: '176px',
          margin: `${Layout.space.md} 12px 0 12px`,
          minWidth: '240px',
          padding: Layout.space.md,
        };
      },
    },
  };
</script>
